import { types, SnapshotIn, SnapshotOut, Instance } from 'mobx-state-tree';
import { DateTime } from './DateTime';

export const TimelineLog = types
  .model({
    id: types.identifierNumber,
    object_id: types.string,
    timestamp: DateTime,
    metadata: types.frozen(),
    event_type: types.string,
    user_name: types.string,
  })
  .views((self) => ({
    get action() {
      return self.event_type.split('.').slice(1).join('.');
    },
    get contentTypeName() {
      return self.event_type.split('.')[0];
    },
  }));

export interface ITimelineLog extends Instance<typeof TimelineLog> {}
export interface ITimelineLogSnapshotIn
  extends SnapshotIn<typeof TimelineLog> {}
export interface ITimelineLogSnapshotOut
  extends SnapshotOut<typeof TimelineLog> {}
